import { styleElement } from './styleSheetHost';

// The store's own stylesheet on the page: one `<style>` placed straight after the sheet the element
// styles are written into, so at equal specificity the merchant's rule is the one that wins. It is set
// as text, never parsed as markup, so nothing in it can end its own tag.

/** Marks the store's own stylesheet, so it is found again rather than added twice. */
const CUSTOM_MARK = 'data-xshop-custom';

// Draws the store's stylesheet on a page, or takes it away when the store has none.
export function mountCustomCss(root: Document, css: string): void {
  const existing = root.head?.querySelector<HTMLStyleElement>(`style[${CUSTOM_MARK}]`) ?? null;
  if (css.trim() === '') {
    existing?.remove();
    return;
  }
  const elements = styleElement(root);
  const sheet = existing ?? root.createElement('style');
  sheet.setAttribute(CUSTOM_MARK, '');
  sheet.textContent = css;
  // Always right after the element sheet, so a rule of the merchant's is read after the theme's own.
  if (elements && elements.nextSibling !== sheet) elements.after(sheet);
  else if (!elements && !existing) root.head?.appendChild(sheet);
}
